// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-accounting-js": function componentSrcPagesAboutAccountingJs() {
    return import("./../../src/pages/about/accounting.js"
    /* webpackChunkName: "component---src-pages-about-accounting-js" */
    );
  },
  "component---src-pages-about-administration-js": function componentSrcPagesAboutAdministrationJs() {
    return import("./../../src/pages/about/administration.js"
    /* webpackChunkName: "component---src-pages-about-administration-js" */
    );
  },
  "component---src-pages-about-index-js": function componentSrcPagesAboutIndexJs() {
    return import("./../../src/pages/about/index.js"
    /* webpackChunkName: "component---src-pages-about-index-js" */
    );
  },
  "component---src-pages-about-regulations-js": function componentSrcPagesAboutRegulationsJs() {
    return import("./../../src/pages/about/regulations.js"
    /* webpackChunkName: "component---src-pages-about-regulations-js" */
    );
  },
  "component---src-pages-about-scheme-js": function componentSrcPagesAboutSchemeJs() {
    return import("./../../src/pages/about/scheme.js"
    /* webpackChunkName: "component---src-pages-about-scheme-js" */
    );
  },
  "component---src-pages-apartments-js": function componentSrcPagesApartmentsJs() {
    return import("./../../src/pages/apartments.js"
    /* webpackChunkName: "component---src-pages-apartments-js" */
    );
  },
  "component---src-pages-contact-us-js": function componentSrcPagesContactUsJs() {
    return import("./../../src/pages/contact-us.js"
    /* webpackChunkName: "component---src-pages-contact-us-js" */
    );
  },
  "component---src-pages-contacts-js": function componentSrcPagesContactsJs() {
    return import("./../../src/pages/contacts.js"
    /* webpackChunkName: "component---src-pages-contacts-js" */
    );
  },
  "component---src-pages-holders-algorithm-js": function componentSrcPagesHoldersAlgorithmJs() {
    return import("./../../src/pages/holders/algorithm.js"
    /* webpackChunkName: "component---src-pages-holders-algorithm-js" */
    );
  },
  "component---src-pages-holders-index-js": function componentSrcPagesHoldersIndexJs() {
    return import("./../../src/pages/holders/index.js"
    /* webpackChunkName: "component---src-pages-holders-index-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-objects-js": function componentSrcPagesObjectsJs() {
    return import("./../../src/pages/objects.js"
    /* webpackChunkName: "component---src-pages-objects-js" */
    );
  },
  "component---src-templates-blog-js": function componentSrcTemplatesBlogJs() {
    return import("./../../src/templates/blog.js"
    /* webpackChunkName: "component---src-templates-blog-js" */
    );
  },
  "component---src-templates-object-js": function componentSrcTemplatesObjectJs() {
    return import("./../../src/templates/object.js"
    /* webpackChunkName: "component---src-templates-object-js" */
    );
  },
  "component---src-templates-objects-list-js": function componentSrcTemplatesObjectsListJs() {
    return import("./../../src/templates/objectsList.js"
    /* webpackChunkName: "component---src-templates-objects-list-js" */
    );
  },
  "component---src-templates-post-js": function componentSrcTemplatesPostJs() {
    return import("./../../src/templates/post.js"
    /* webpackChunkName: "component---src-templates-post-js" */
    );
  }
};